import {
  Component,
  ViewEncapsulation,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from "@angular/core";
import { AlertsDataService } from "src/app/shared/alerts/alerts-data.service";
import { Dictionary } from "src/app/store/models/common_types";
import {
  faCaretDown,
  faCaretUp,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { AlertsService } from "src/app/shared/alerts/alerts.service";

@Component({
  selector: "app-watchlist-alerts",
  templateUrl: "./watchlist-alerts.component.html",
  styleUrls: ["./watchlist-alerts.component.scss"],
  encapsulation: ViewEncapsulation.None,
  host: { class: "watchlist-alerts" },
})
export class WatchlistAlertsComponent implements OnChanges {
  @Input() disableAlerts: boolean;
  @Input() watchlistId: string;
  @Output() alertsData = new EventEmitter<any>();
  allEventTypes: Array<any>;
  triggerType = "watchlist";
  faCaretDown = faCaretDown;
  faCaretUp = faCaretUp;
  faInfoCircle = faInfoCircle;
  allEntitled = false;
  notificationOptions: Dictionary<boolean> = {
    systemAlert: false,
    instant: false,
    daily: true,
    weekly: false,
  };
  isBrokerListVisible = false;
  brokerList: Array<any> = [];
  brokerSearchText = "";
  selectedBrokers: Array<any> = [];
  alertsDataToSend: Dictionary<any> = {};
  constructor(
    private alertsDataService: AlertsDataService,
    private alertsService: AlertsService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.watchlistId &&
      changes.watchlistId.currentValue !== changes.watchlistId.previousValue
    ) {
      this.bindAlertsData();
    }
  }

  returnAlertsData() {
    this.alertsData.emit(this.alertsDataToSend);
  }

  bindAlertsData() {
    this.alertsDataService
      .getAllEventTypes(this.triggerType, this.watchlistId, true)
      .subscribe(
        (response) => {
          this.allEventTypes = response.eventTypes;

          this.alertsDataToSend = {
            alert_email_frequency: ["daily"],
            alert_event_types: [],
            toast_notifications: true,
            alert_trigger_type: this.triggerType,
            alert_trigger_id: this.watchlistId,
            alert_event_type_items_map: {},
          };

          response.eventTypes.forEach((type) => {
            if (type.default_check_in_watchlist) {
              if (type.display_name === "Earnings Preview") {
                type.subcategories.forEach((sub) => {
                  if (sub.default_check_in_watchlist) {
                    this.alertsDataToSend.alert_event_types.push(sub.name);
                  }
                });
              } else {
                this.alertsDataToSend.alert_event_types.push(type.name);
              }
            }
          });

          this.returnAlertsData();
        },
        (error) => {
          throw error;
        },
      );
    this.alertsDataService
      .getUserBrokerEntitlementMap(this.watchlistId, true)
      .subscribe(
        (response) => {
          this.brokerList = response.watchlist_entitled_broker_map[
            this.watchlistId
          ].sources.map((broker) => {
            return {
              label: broker,
              visible: true,
            };
          });
        },
        (error) => {
          console.error(error);
        },
      );
  }

  onClickViewAllBrokers() {
    this.isBrokerListVisible = !this.isBrokerListVisible;
  }

  onBrokerSearchChange() {
    this.brokerList = this.brokerList.map((data) => {
      if (
        data.label.toLowerCase().indexOf(this.brokerSearchText.toLowerCase()) >
        -1
      ) {
        data.visible = true;
      } else {
        data.visible = false;
      }
      return data;
    });
  }

  onChangeAllEntitled() {
    this.brokerList.map((x) => {
      x.checked = this.allEntitled;
      return x;
    });
    this.onBrokerChanges(this.allEntitled, "brokerChange");
  }

  onBrokerChanges(onBrokerChanges?: boolean, from?: string) {
    const params = this.alertsService.onBrokerChanges(
      this.brokerList,
      onBrokerChanges,
      this.allEntitled,
      this.triggerType,
    );
    this.selectedBrokers = params.selectedBrokers;
    this.allEntitled = params.allEntitledBrokers;

    this.allEventTypes.map((data) => {
      if (data.display_name === "New Model") {
        if (from && from === "brokerChange") {
          if (this.selectedBrokers.length > 0) {
            data.default_check_in_watchlist = true;
          } else {
            data.default_check_in_watchlist = false;
          }
        }

        if (!data.default_check_in_watchlist) {
          if (this.alertsDataToSend.alert_event_types.indexOf(data.name) > -1) {
            this.alertsDataToSend.alert_event_types.splice(
              this.alertsDataToSend.alert_event_types.indexOf(data.name),
              1,
            );
          }
        } else {
          if (
            this.alertsDataToSend.alert_event_types.indexOf(data.name) === -1
          ) {
            this.alertsDataToSend.alert_event_types.push(data.name);
          }
        }

        this.alertsDataToSend.alert_event_type_items_map[data.name] = {
          list: this.selectedBrokers,
          all_entitled_objects:
            JSON.stringify(this.brokerList.map((x) => x.broker_name).sort()) ===
            JSON.stringify(this.selectedBrokers.sort()),
        };
      }
      return data;
    });
    this.returnAlertsData();
  }

  onEPChanges() {
    this.alertsService.onEPChanges(
      this.allEventTypes,
      this.alertsDataToSend,
      "watchlist",
    );
    this.returnAlertsData();
  }

  onClickEventType(params) {
    this.alertsService.onClickEventType(
      params,
      false,
      this.allEventTypes,
      this.alertsDataToSend,
      this.brokerList,
      "watchlist",
    );
    if (params.display_name === "New Model") {
      this.onBrokerChanges(params.default_check_in_watchlist);
    }
    this.returnAlertsData();
  }

  onNotificationChanges(param: Array<string>) {
    const frequency = param.filter((frequency) => {
      return frequency !== "systemAlert";
    });
    this.alertsDataToSend.alert_email_frequency = frequency;
    this.returnAlertsData();
  }

  onClearBrokerSearch() {
    this.brokerSearchText = "";
    this.onBrokerSearchChange();
  }
}
